import React, { useMemo } from 'react';
import { Card, Tabs } from 'antd';
import PaginatedTable, { PaginatedTableProps } from '../../../../common/PaginatedTable';
import { VisaApplication } from '../types/visa-application.types';
import type { Status } from '../../statuses/types/status.types';
import { useTranslation } from 'react-i18next';

interface VisaApplicationTableProps extends PaginatedTableProps<VisaApplication> {
  selectedTab?: string | null;
  onTabChange?: (statusId: string) => void;
  statuses?: Status[];
}

const ALL_APPLICATIONS_TAB_KEY = 'all';

const VisaApplicationTable = (props: VisaApplicationTableProps) => {
  const { selectedTab, onTabChange, statuses = [] } = props;
  const { t } = useTranslation();

  const tabItems = useMemo(() => {
    const allTab = {
      key: ALL_APPLICATIONS_TAB_KEY,
      label: t('visaApplications.allApplications'),
    };
    const statusTabs = statuses.map((status) => ({
      key: status.id,
      label: status.statusCode,
    }));
    return [allTab, ...statusTabs];
  }, [statuses, t]);

  const handleTabChange = (activeKey: string) => {
    if (onTabChange) {
      onTabChange(activeKey);
    }
  };

  return (
    <>
      {/* Commented out tabs - only showing "All Applications" */}
      {/* <Tabs
        activeKey={selectedTab || undefined}
        items={tabItems}
        onChange={handleTabChange}
        className="mb-3"
      /> */}
      <Card className="shadow-lg">
        <PaginatedTable<VisaApplication>
          data={props.data}
          columns={props.columns}
          loading={props.loading}
          pagination={props.pagination}
          rowKey={props.rowKey}
          onPageChange={props.onPageChange}
          onPageSizeChange={props.onPageSizeChange}
          className={props.className}
          showSizeChanger={props.showSizeChanger}
          tableProps={props.tableProps}
          showSearchBar={props.showSearchBar}
          onSearchChange={props.onSearchChange}
          showFilters={props.showFilters}
          availableFilters={props.availableFilters}
          onFilterChange={props.onFilterChange}
          sortField={props.sortField}
          sortOrder={props.sortOrder}
        />
      </Card>
    </>
  );
};

export default React.memo(VisaApplicationTable);
